        <div [formGroup]="form">
            <!-- Row 1: User Type, Product Category, Product & Region -->
            <div class="row">
              <div class="col-md-3">
                <div class="form-group mb-3">
                  <label for="userType" class="form-label">{{ labels.userType }}</label>
                  <select
                    id="userType"
                    class="form-control"
                    formControlName="userType">
                    <option value="" disabled selected>{{ placeholders.selectUserType }}</option>
                    <option *ngFor="let type of userTypes" [value]="type">
                      {{ type }}
                    </option>
                  </select>
                </div>
              </div>

              <app-product-category-fields [form]="form" [lang]="lang" columnClass="col-md-3"></app-product-category-fields>

              <div class="col-md-3" *ngIf="lang === 'en'">
                <div class="form-group mb-3">
                  <label for="region" class="form-label">Region <span class="ast">*</span></label>
                  <select
                    id="region"
                    class="form-control"
                    formControlName="region"
                    [class.is-invalid]="isFieldInvalid('region')">
                    <option value="" disabled selected>Select a region</option>
                    <option value="UK">UK</option>
                    <option value="EU">EU</option>
                    <option value="INT">Rest of world</option>
                  </select>
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('region')">
                      {{ messages.fieldRequired }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Row 2: Description -->
            <div class="row">
              <div class="col-md-12">
                <div class="form-group mb-3">
                  <label for="description" class="form-label">{{ labels.describeRequest }} <span class="ast">*</span></label>
                  <textarea
                    id="description"
                    class="form-control"
                    formControlName="description"
                    [class.is-invalid]="isFieldInvalid('description')"
                    rows="4"
                    placeholder="{{ placeholders.describeYourRequest }}" maxlength="2000"></textarea>
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('description')">
                    <span *ngIf="form.get('description')?.hasError('required')">
                      {{ messages.fieldRequired }}
                    </span>
                    <span *ngIf="form.get('description')?.hasError('minlength')">
                      {{ messages.characterLimit }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
      
        </div>
